module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/bg-dotted-07ccca9fb5e2e764e983e1a23ee205e5.svg";